import { Component, Input } from "@angular/core";
import { MagicSetProgress } from "./magic-collection-sets.component";
import { UpperCasePipe } from "@angular/common";
import { MagicSetIconComponent } from "@ponder-features/magic/set/magic-set-icon.component";
import { environment } from "../../../../../environments/environment";
import { isMobileScreen } from "@ponder-shared/utils/screenBreakpoints";

@Component({
    selector: "magic-collection-set",
    imports: [UpperCasePipe, MagicSetIconComponent],
    templateUrl: "./magic-collection-set.component.html"
})
export class MagicCollectionSetComponent {
    @Input({ required: true }) public magicSet!: MagicSetProgress;
    public rarity: string = "uncommon";
    public rarityColor: string = environment.colors.magic.uncommon;

    public ngOnInit(): void {
        if (this.magicSet.percentage == 100) {
            this.rarity = "mythic";
            this.rarityColor = environment.colors.magic.mythic;
        } else if (this.magicSet.percentage > 85) {
            this.rarity = "rare";
            this.rarityColor = environment.colors.magic.rare;
        }
    }

    public isMobileScreen(): boolean {
        return isMobileScreen();
    }
}